const colors = ['#6157ff', '#999999', '#f2765d'];
const expression = { low: 'Low Expression', 'low expression': 'Low Expression', high: 'High Expression', 'high expression': 'High Expression' };
const labels = {
  mrna: expression, rnaseq: expression, mrnarnaseq: expression, mirna: expression, protein: expression,
  methylation: { low: 'Hypomethylated', intermediate: 'Heterogeneously Methylated', high: 'Hypermethylated' },
  cnv: { loss: 'Copy-number Loss', normal: 'Normal Copy Number', gain: 'Copy-number Gain' },
  mutation: { 'not present': 'Mutation Absent', present: 'Mutation Present' },
  fusion: { 'not present': 'Fusion Absent', present: 'Fusion Present' },
};

// Keep API groups intact; translate only at the display boundary.
export function survivalGroupDisplay(dataType, group, index = 0) {
  const type = String(dataType || '').toLowerCase().replace(/[^a-z0-9]/g, '');
  const value = String(group || '').trim().toLowerCase();
  const colorIndex = {
    low: 0, 'low expression': 0, loss: 0, 'not present': 0,
    intermediate: 1, normal: 1,
    high: 2, 'high expression': 2, gain: 2, present: 2,
  }[value];
  return { label: labels[type]?.[value] || group, color: colors[colorIndex ?? index % colors.length] };
}
